import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcReportsIcon = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M3.25 4A2.75 2.75 0 0 1 6 1.25h12A2.75 2.75 0 0 1 20.75 4v16A2.75 2.75 0 0 1 18 22.75H6A2.75 2.75 0 0 1 3.25 20V4ZM6 2.75c-.69 0-1.25.56-1.25 1.25v16c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V4c0-.69-.56-1.25-1.25-1.25H6Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M9.5 6.5a1 1 0 0 1 2 0v5a1 1 0 1 1-2 0v-5Zm6 0a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0v-5Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M6.25 15.5a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Zm0 3a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M6.5 9.5a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0v-2Zm6-1a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0v-3Z",
  fill: "var(--mds-nav-icon-medium)"
})), "IcReportsIcon");

export { IcReportsIcon };
//# sourceMappingURL=ic-reports-icon.js.map
